import warningIcon from "$assets/icons/warning-icon.svg?url";
import { Button } from "$components/button/button";
import { DialogBody } from "$components/dialog/dialog-body";
import { DialogContainer } from "$components/dialog/dialog-container";
import { DialogFooter } from "$components/dialog/dialog-footer";
import { DialogHeader } from "$components/dialog/dialog-header";
import { Box, makeStyles, Typography } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import useFinaliseInvoice from "./hooks/useFinaliseInvoice";

const useStyles = makeStyles((theme) => ({
  modal: {
    borderRadius: theme.spacing(3),
  },
  warningMessage: {
    color: theme.palette.grey[600],
    fontWeight: 400,
    marginLeft: theme.spacing(0.5),
  },
  warningIcon: {
    marginRight: theme.spacing(2),
  },
}));

export const FinaliseInvoiceModal: FC<{
  invoiceId: string;
  open: boolean;
  onClose: () => void;
}> = ({ invoiceId, open, onClose }) => {
  const classes = useStyles();
  const { finaliseInvoice } = useFinaliseInvoice(invoiceId);
  const [busy, setBusy] = useState(false);

  const handleFinalise = async () => {
    setBusy(true);
    try {
      await finaliseInvoice();
    } finally {
      onClose();
    }
  };

  return (
    <DialogContainer open={open} className={classes.modal}>
      <DialogHeader title="">
        <Box display="flex" alignItems="center">
          <img
            src={warningIcon}
            alt="warning"
            className={classes.warningIcon}
          />
          <Typography variant="h5">
            <FormattedMessage
              id="invoicing.confirmation.title"
              defaultMessage="Finalise Invoice?"
            />
          </Typography>
        </Box>
      </DialogHeader>
      <DialogBody>
        <Typography variant="h6" className={classes.warningMessage}>
          <FormattedMessage
            id="invoicing.confirmation.warning"
            defaultMessage="Once you finalise you will not be able to do further edits."
          />
        </Typography>
      </DialogBody>
      <DialogFooter>
        <Button color="secondary" onClick={() => onClose()} disabled={busy}>
          <FormattedMessage
            id="invoicing.confirmation.cancel"
            defaultMessage="Cancel"
          />
        </Button>
        <Button
          onClick={handleFinalise}
          color="primary"
          data-testid="invoicing.confirmation.accept"
          startIcon={<CheckIcon />}
          loading={busy}
        >
          <FormattedMessage
            id="invoicing.confirmation.accept"
            defaultMessage="Finalise"
          />
        </Button>
      </DialogFooter>
    </DialogContainer>
  );
};

export default FinaliseInvoiceModal;
